import { IfData } from 'src/utils/insuranceFund';
import { WithClassName } from 'src/utils/UtilityTypes';
import { SpotMarketConfig } from '@velocity-exchange/sdk';
import SecondaryConnectWalletButton from 'src/components/SecondaryConnectWalletButton';
import Button from 'src/components/primitives/Button/Button';
import { cj } from 'src/utils/classNames';
import useActionButtons from './useActionButtons';

const CardActionButtons = ({
	ifData,
	spotMarket,
	className,
}: {
	ifData: IfData | undefined;
	spotMarket: SpotMarketConfig;
} & WithClassName) => {
	const {
		connected,
		accountIsDelegate,
		submitting,
		isStakeDisabled,
		requestWithdrawPaused,
		withdrawPaused,
		unstakeInProgress,
		canWithdraw,
		currentStake,
		handleClickStakeButton,
		handleClickUnstakeButton,
	} = useActionButtons({ ifData, spotMarket });

	if (!connected) {
		return (
			<div className={cj('flex w-full items-center justify-center', className)}>
				<SecondaryConnectWalletButton />
			</div>
		);
	}

	return (
		<div
			className={cj(
				'flex w-full flex-row items-center justify-between gap-x-lg',
				className
			)}
		>
			{!unstakeInProgress && (
				<Button
					variant="secondary"
					size="md"
					className="w-full"
					onClick={handleClickStakeButton}
					isLoading={submitting}
					disabled={isStakeDisabled}
				>
					Stake
				</Button>
			)}
			{currentStake > 0 && (
				<Button
					variant="secondary"
					size="md"
					className="w-full"
					disabled={
						currentStake === 0 ||
						submitting ||
						accountIsDelegate ||
						(unstakeInProgress && canWithdraw && withdrawPaused) ||
						(!unstakeInProgress && requestWithdrawPaused)
					}
					isLoading={submitting}
					onClick={handleClickUnstakeButton}
				>
					{unstakeInProgress
						? canWithdraw
							? 'Withdraw'
							: 'Cancel Unstake'
						: 'Unstake'}
				</Button>
			)}
		</div>
	);
};

export default CardActionButtons;
